var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":"Mission statement","label-for":"mission"}},[_c('b-form-textarea',{attrs:{"id":"mission","rows":"3"},model:{value:(_vm.statement),callback:function ($$v) {_vm.statement=$$v},expression:"statement"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }